import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card, Nav, Tab } from "react-bootstrap";
import UserImg from "../../assets/img/dpmain.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useProfileContext } from "provider/ProfileProvider";
import apiCall, { apiCall2 } from "components/Api/api";
import { formatDateMonthYear } from "components/Api/common";
import { useToast } from "provider/ToastProvider";
import { useAuth } from "provider/AuthContext";
import { handleError } from "components/Api/handleError";

const Following = () => {
  const { user_handle } = useParams();
  const { showErrorToast, showSuccessToast } = useToast();
  const { isLoggedIn, userProfile, logout } = useAuth();
  const navigate = useNavigate();
  const { userProfileView, profileDispatch, following, summaryFollowing, pageIndexFollowing, } = useProfileContext();
  const [loading, setLoading] = useState();
  const [followLoading, setFollowLoading] = useState(false);
  // const [following, setFollowingData] = useState([]);

  useEffect(() => {

    const fetchData = async () => {
      try {
        setLoading(true);

        const [followingRes] = await Promise.all([
          apiCall2({
            url: `${userProfileView?.urls?.followings_list}?pageSize=10&page=${pageIndexFollowing}`,

            method: "GET",
          }),

        ]);

        // Handle errors in either response
        if (followingRes?.status === 200 && !followingRes?.data?.errors) {
          const followingData = followingRes?.data?.user_follower_list?.data || [];
          const parkSummary = followingRes?.data?.user_follower_list?.summary;
          if (pageIndexFollowing === 1) {
            profileDispatch({ type: "SET_PROFILE_FOLLOWING_DATA", payload: followingData });
          } else {
            profileDispatch({ type: "APPEND_PROFILE_FOLLOWING_DATA", payload: followingData });
          }

          profileDispatch({
            type: "PROFILE_FOLLOWING_SUMMARY",
            payload: {
              total: parkSummary.total,
              page: parkSummary.page,
              pageSize: parkSummary.pageSize,
              total_page: parkSummary.total_page,
            },
          });
        } else {
          console.error("Organized safari error:", followingRes?.data?.errors);
        }



      } catch (err) {
        console.error("Error in parallel fetch:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userProfileView?.urls?.followings_list, pageIndexFollowing]);

  const processedFollowingData = useMemo(() => {
    return following?.map((follower) => ({
      ...follower,
    }));
  }, [following]);

  const followUsers = async (e, is_followed, follower) => {
    e.preventDefault();
    try {
      setFollowLoading(true);
      const URL = is_followed ? `profile/unfollow?user_handle=${user_handle}` : `profile/follow?user_handle=${user_handle}`
      const response = await apiCall({
        url: URL,
        method: "POST",
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const errors = apiData.errors;
        // Dynamically set errors based on the response
        Object.keys(errors).forEach((key) => {
          const errorMessages = errors[key];
          const firstErrorMessage = errorMessages[0];
          // Set the error state for the corresponding field
          showErrorToast(firstErrorMessage);

        });
        return;
      }
      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        const updatedFollowers = following?.map((f) => {
          if (f.user_handle === follower.user_handle) {
            return { ...f, is_followed: !is_followed }; // Toggle follow status
          }
          return f;
        });
        profileDispatch({
          type: 'SET_PROFILE_FOLLOWING_DATA',
          payload: updatedFollowers,
        });

      }
    } catch (error) {
      console.error("Error submitting form:", error.message);
      // Optionally show error UI feedback here
      handleError(error, logout, navigate);

    } finally {

      setFollowLoading(false);
    }

  }


  return (
    <>
      <Row className="mb-5 itenary_tabs">
        <Col md={12} className="">
          <h6 className="fs-5 fw-bold pb-3">Following</h6>
        </Col>
        <Col xs={12}>
          <Card className="safartabs">
            <Card.Body>
              <Tab.Container defaultActiveKey="follower">
                <Nav
                  className="nav  nav-tabs border-bottom"
                  id="myTab"
                  role="tablist"
                >
                  <Nav.Item role="presentation">
                    <Nav.Link eventKey="follower" className="nav-link">
                      Profile Following
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content className="pt-4">
                  <Tab.Pane eventKey="follower">
                    <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-5">
                      {Array.isArray(processedFollowingData) &&
                        processedFollowingData.length > 0 ? (
                        <>
                          {processedFollowingData.map((follower, index) => (
                            <Col
                              md={6} sm={6} lg={4} className="mb-4"
                              key={follower.id || index}
                            >
                              <Col className="mb-3">
                                <Card className="card_profile h-100 position-relative">
                                  <div className="dots-blockbox">
                                    <i className="fa-solid fa-ellipsis"></i>
                                    <div
                                      className="box_dropdown"
                                      style={{ display: "none block" }}
                                    >
                                      <Link to="" className="d-block pb-1">
                                        Viwe Profile
                                      </Link>
                                      <Link to="" className="d-block">
                                        Block
                                      </Link>
                                    </div>
                                  </div>
                                  <div className="profileDetails text-center">
                                    <Link to="">
                                      <div
                                        className="mx-auto white"
                                        style={{
                                          width: "70px",
                                          height: "70px",
                                        }}
                                      >
                                        <img
                                          src={follower?.profile_display_image || UserImg}
                                          className="rounded-circle img-fluid"
                                          alt="profile-image"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = UserImg;
                                          }}
                                        />
                                      </div>
                                      <Card.Body className="text-center pt-2">
                                        <h6 className="fs-7 fw-bold usename">
                                          {follower?.display_name}
                                        </h6>
                                        <h6 className="fs-6 joint-text">
                                          {formatDateMonthYear(follower?.joined_at)}
                                        </h6>
                                        {/*<div className="followres-count pt-3">
                                          <div className="folloerwstext">
                                            219 Followers
                                          </div>
                                        </div> */}
                                      </Card.Body>
                                    </Link>

                                    <div className="followunfollowbtn border-top">
                                      <Row>
                                        <Col xs={6} className="divider">
                                          <div className="folollowBtns">
                                            <Link to="" role="button"
                                              onClick={(e) => {
                                                followUsers(e, follower?.is_followed, follower);
                                              }}

                                            >
                                              {follower?.is_followed ? 'Unfollow' : 'Follow'}
                                            </Link>
                                          </div>
                                        </Col>
                                        <Col xs={6}>
                                          <div className="massegses">
                                            <Link to="/chat">Message</Link>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Card>
                              </Col>
                            </Col>
                          ))}
                        </>
                      ) :
                        <p>No Following Found</p>
                      }

                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
              <div className="d-flex justify-content-center my-4">
                {loading ? (
                  <div
                    className="spinner-border loading-spinner"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  summaryFollowing?.page < summaryFollowing?.total_page && (
                    <button
                      className="join_btn newbgjoin mt-sm-0 mt-2"
                      onClick={() => {

                        const nextPage = pageIndexFollowing + 1
                        profileDispatch({
                          type: "PROFILE_FOLLOWERS_PAGE_INDEX",
                          payload: nextPage,
                        });
                      }}
                    >
                      Show More
                    </button>
                  )
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Following;
